export const navItems = [
  { id: "overview", label: "作品速览", icon: "ri-book-2-line" },
  { id: "story", label: "故事背景", icon: "ri-quill-pen-line" },
  { id: "characters", label: "人物类型", icon: "ri-group-line" },
  { id: "resources", label: "阅读资源", icon: "ri-folder-download-line" },
  { id: "path", label: "阅读脉络", icon: "ri-route-line" },
  { id: "highlights", label: "主题看点", icon: "ri-sparkling-2-line" },
  { id: "tips", label: "阅读贴士", icon: "ri-lightbulb-line" },
  { id: "faq", label: "常见问题", icon: "ri-question-answer-line" },
];

export const heroStats = [
  { value: "小说", label: "完整文本", icon: "ri-book-open-line" },
  { value: "漫画", label: "分话全集", icon: "ri-image-2-line" },
  { value: "TXT", label: "无删减格式", icon: "ri-file-text-line" },
  { value: "多端", label: "手机 / 电脑阅读", icon: "ri-smartphone-line" },
];

export const quickFacts = [
  { label: "作品名称", value: "漂亮的保姆", icon: "ri-bookmark-line" },
  { label: "作品类型", value: "都市情感 · 家庭生活", icon: "ri-heart-2-line" },
  { label: "呈现形式", value: "小说 · 漫画", icon: "ri-stack-line" },
  { label: "资源格式", value: "TXT 文本 · 图片章节", icon: "ri-file-text-line" },
  { label: "阅读方式", value: "整本合集 / 分章阅读", icon: "ri-list-check" },
  { label: "适合人群", value: "喜爱家庭情感题材的读者", icon: "ri-user-heart-line" },
  { label: "内容特点", value: "情节连贯 · 人物鲜明", icon: "ri-emotion-happy-line" },
  { label: "版本倾向", value: "以整理完整的无删减版本为主", icon: "ri-check-double-line" },
];

export const synopsisLead =
  "《漂亮的保姆》属于都市情感与家庭生活交织的题材。故事把日常生活的琐碎与人物之间的情感变化放在同一条线索上，通过一段段平凡却细腻的相处，逐步展开关于陪伴、信任与成长的话题。下面整理的是这一类作品常见的背景信息与阅读方向，方便你在开始阅读前先建立整体印象。";

export const synopsisPoints = [
  {
    title: "生活化的场景",
    icon: "ri-home-4-line",
    desc: "故事大多发生在家庭、社区、职场等贴近日常的场所，环境描写偏写实，读起来代入感较强，适合喜欢慢热叙事的读者。",
  },
  {
    title: "从相处到理解",
    icon: "ri-chat-heart-line",
    desc: "主线围绕人物之间由陌生到熟悉的过程展开，冲突往往来自误解与性格差异，而非刻意的戏剧化设定，节奏相对平缓。",
  },
  {
    title: "情感与现实的拉扯",
    icon: "ri-scales-3-line",
    desc: "作品往往把个人情感与现实条件放在一起讨论，例如工作压力、家庭责任与自我选择之间的矛盾，让情节更具现实质感。",
  },
  {
    title: "细节堆积的张力",
    icon: "ri-magic-line",
    desc: "很多打动人的段落并不依赖大事件，而是通过一句对话、一个动作的细节慢慢累积情绪，因此更适合静下心连续阅读。",
  },
];

export const characterRoles = [
  {
    role: "保姆 · 女主",
    icon: "ri-user-star-line",
    tag: "核心视角",
    desc: "整部作品的主要视角人物，通常承担照顾家庭日常的工作。性格细腻、有耐心也带着韧性，在琐碎事务中逐渐找到自己的位置。",
    traits: ["细腻", "坚韧", "观察力强"],
  },
  {
    role: "雇主 · 男主",
    icon: "ri-user-3-line",
    tag: "关键关系",
    desc: "家庭中与女主互动最多的人物，往往工作繁忙、性格内敛。外冷内暖的反差是推动关系变化的重要来源。",
    traits: ["内敛", "责任感强", "外冷内暖"],
  },
  {
    role: "家中的孩子",
    icon: "ri-emotion-normal-line",
    tag: "情感纽带",
    desc: "串联起整个家庭情感线的关键存在。孩子对女主的态度变化，常常是最直观反映人物关系走向的信号。",
    traits: ["天真", "敏感", "依赖"],
  },
  {
    role: "同住的长辈",
    icon: "ri-user-4-line",
    tag: "矛盾来源",
    desc: "常见的家庭长辈设定，观念相对传统，对女主的态度在不同阶段有明显变化，是制造日常冲突与和解的重要角色。",
    traits: ["传统", "嘴硬心软", "重规矩"],
  },
  {
    role: "朋友 / 同事",
    icon: "ri-contacts-line",
    tag: "外部视角",
    desc: "处于家庭之外的旁观者，负责提供另一种看法与情绪出口，也常常在关键节点给出提醒或推动剧情向前。",
    traits: ["直率", "理性", "仗义"],
  },
  {
    role: "转折型配角",
    icon: "ri-flashlight-line",
    tag: "剧情推手",
    desc: "戏份不多但出现时机关键，往往在关系即将稳定时带来新的变数，让故事重新进入张力的阶段。",
    traits: ["神秘", "目的性强", "充满变数"],
  },
];

export const resourceCategories = [
  { key: "all", label: "全部资源" },
  { key: "novel", label: "小说文本" },
  { key: "comic", label: "漫画资源" },
  { key: "format", label: "格式与说明" },
];

export const resourceItems = [
  {
    id: "novel-full",
    category: "novel",
    title: "小说无删减全集 TXT",
    format: "TXT",
    icon: "ri-book-open-line",
    desc: "将《漂亮的保姆》小说正文按章节顺序整理为单个 TXT 文件，保留完整内容，适合一次性通读或放入阅读器长期保留。",
    points: ["整本合一", "章节按序", "适合收藏"],
  },
  {
    id: "novel-chapter",
    category: "novel",
    title: "分章节 TXT 阅读包",
    format: "TXT",
    icon: "ri-file-list-2-line",
    desc: "把正文拆分为独立章节文件，方便逐章阅读与进度管理，适合习惯每天读一点、不追求一次读完的读者。",
    points: ["逐章拆分", "便于断点", "占用更小"],
  },
  {
    id: "novel-proofread",
    category: "novel",
    title: "校对整理版文本",
    format: "TXT",
    icon: "ri-check-double-line",
    desc: "在原始文本基础上统一了标点与段落缩进，修正明显的错别字与断行问题，减少阅读过程中的干扰。",
    points: ["统一标点", "规整段落", "阅读更顺"],
  },
  {
    id: "comic-full",
    category: "comic",
    title: "漫画全集整理",
    format: "图片 / 压缩包",
    icon: "ri-image-2-line",
    desc: "按话数顺序汇编《漂亮的保姆》漫画内容，进行重新编号与排序，便于连续浏览完整的画面叙事。",
    points: ["全话收录", "重新编号", "顺序清晰"],
  },
  {
    id: "comic-parts",
    category: "comic",
    title: "漫画分话阅读资源",
    format: "图片 / 压缩包",
    icon: "ri-layout-grid-line",
    desc: "以单话为单位提供的漫画资源，适合按话追更、收藏或对照小说原文查看情节差异。",
    points: ["单话独立", "方便对照", "按需查看"],
  },
  {
    id: "comic-quality",
    category: "comic",
    title: "高清画质整理说明",
    format: "说明",
    icon: "ri-hd-line",
    desc: "整理漫画在不同设备上的显示建议与画质说明，帮助你选择合适的清晰度，兼顾观感与存储空间。",
    points: ["画质分级", "设备建议", "存储提示"],
  },
  {
    id: "format-guide",
    category: "format",
    title: "TXT 排版与编码说明",
    format: "说明",
    icon: "ri-file-settings-line",
    desc: "解释 TXT 资源常见的编码与排版问题，例如乱码、段落粘黏的成因与处理方式，避免打开后出现阅读障碍。",
    points: ["编码说明", "排版规范", "问题排查"],
  },
  {
    id: "format-reader",
    category: "format",
    title: "阅读器与阅读方式建议",
    format: "说明",
    icon: "ri-device-line",
    desc: "对比手机、平板与电脑上不同阅读方式的特点，给出字体、行距与护眼设置的参考，让长文本读起来更轻松。",
    points: ["多端对比", "护眼设置", "行距建议"],
  },
];

export const readingPath = [
  {
    stage: "第一阶段",
    title: "相遇与铺垫",
    icon: "ri-door-open-line",
    desc: "交代女主进入家庭工作的缘由与初到新环境的处境，同时通过日常细节建立人物之间的初步印象，为后续关系变化埋下伏笔。",
  },
  {
    stage: "第二阶段",
    title: "相处与磨合",
    icon: "ri-hand-heart-line",
    desc: "女主逐渐熟悉家中的节奏，与家庭成员之间出现摩擦也产生默契。这一阶段的重点是关系从生疏走向自然的过程。",
  },
  {
    stage: "第三阶段",
    title: "冲突与转折",
    icon: "ri-flashlight-line",
    desc: "随着长辈态度、外部人物或现实问题介入，原有平衡被打破，人物的选择开始影响故事走向，情绪张力明显上升。",
  },
  {
    stage: "第四阶段",
    title: "选择与靠近",
    icon: "ri-heart-3-line",
    desc: "在矛盾缓解之后，人物重新审视彼此的关系，情感线进入更明确的阶段，一些前期埋下的细节在此得到回应。",
  },
  {
    stage: "第五阶段",
    title: "收束与余韵",
    icon: "ri-sun-line",
    desc: "主要矛盾得到处理，人物各自找到位置，故事以相对平缓的方式收尾，留下关于陪伴与成长的余味。",
  },
];

export const highlightTabs = [
  { key: "emotion", label: "情感线" },
  { key: "character", label: "人物塑造" },
  { key: "narrative", label: "叙事节奏" },
  { key: "atmosphere", label: "氛围质感" },
];

export const highlightGroups = [
  {
    key: "emotion",
    items: [
      {
        title: "从照顾到牵挂",
        icon: "ri-heart-2-line",
        desc: "情感的变化藏在一次次做家务、等门、递热水的日常动作里，很少直白表达，却更容易被读者捕捉到。",
      },
      {
        title: "克制的靠近",
        icon: "ri-shield-star-line",
        desc: "人物习惯用行动代替语言，被误解时也不急着解释，这种克制让人物关系显得真实，也更有回味空间。",
      },
      {
        title: "现实感的考验",
        icon: "ri-scales-3-line",
        desc: "情感并不是孤立存在的，它要与责任、家庭意见与现实条件周旋，因此每一次靠近都显得来之不易。",
      },
    ],
  },
  {
    key: "character",
    items: [
      {
        title: "女主的成长弧线",
        icon: "ri-plant-line",
        desc: "女主并非一开始就从容的人，读者能看到她从不自信到逐渐站稳的过程，成长线条清晰且贴合现实。",
      },
      {
        title: "反差的层次感",
        icon: "ri-user-3-line",
        desc: "主要人物往往有表面与内里的不同，随着剧情推进逐层展开，避免了扁平化的人物印象。",
      },
      {
        title: "配角的真实功能",
        icon: "ri-contacts-line",
        desc: "配角不只是点缀，他们各自承担推动情节、提供对照或制造阻力作用，让整体群像更立体。",
      },
    ],
  },
  {
    key: "narrative",
    items: [
      {
        title: "日常为骨，事件为点",
        icon: "ri-calendar-line",
        desc: "整体以日常生活为骨架，重要事件作为节点穿插其间，读起来不疾不徐，适合连续阅读。",
      },
      {
        title: "细节回收",
        icon: "ri-link-m",
        desc: "前期出现的对话、物品或习惯，往往在后面的情节里被重新提起，形成前后呼应的阅读乐趣。",
      },
      {
        title: "张弛有度",
        icon: "ri-pulse-line",
        desc: "紧张段落之后会给出一段平静内容缓和节奏，让情绪有落点，不易产生阅读疲劳。",
      },
    ],
  },
  {
    key: "atmosphere",
    items: [
      {
        title: "烟火气的生活感",
        icon: "ri-restaurant-line",
        desc: "厨房的声音、傍晚的灯光、饭桌上的对话，这些场景让作品带有明显的生活温度。",
      },
      {
        title: "安静的叙事镜头",
        icon: "ri-camera-lens-line",
        desc: "很多段落像安静的镜头，停留在一个人独处或发呆的时刻，让情绪得以自然沉淀。",
      },
      {
        title: "季节与情绪呼应",
        icon: "ri-leaf-line",
        desc: "环境变化常与人物情绪相互映照，季节的推移也暗示着关系状态的转变。",
      },
    ],
  },
];

export const readingTips = [
  {
    title: "先看速览，再进入正文",
    icon: "ri-eye-line",
    desc: "如果只是初次接触，建议先浏览本页的作品速览与故事背景，建立人物与题材的整体印象，再决定用小说还是漫画的形式开始阅读。",
  },
  {
    title: "TXT 编码先确认",
    icon: "ri-code-s-slash-line",
    desc: "打开 TXT 若出现乱码，多为编码不一致导致，切换为 UTF-8 或 GBK 通常即可正常显示，避免误认为资源损坏。",
  },
  {
    title: "按章阅读更轻松",
    icon: "ri-file-list-2-line",
    desc: "长文本建议使用分章文件并在阅读器中设置书签，方便随时续读，也能更好地把握每章的信息量。",
  },
  {
    title: "调整字体与行距",
    icon: "ri-font-size-2",
    desc: "中文长文适合略大的字号与较宽松的行距，长时间阅读时能明显减轻视觉疲劳，手机端尤其建议开启护眼模式。",
  },
  {
    title: "小说漫画对照看",
    icon: "ri-layout-grid-line",
    desc: "同一作品的小说与漫画在叙事侧重上常有差异，对照阅读可以发现更多细节，也能更直观地理解人物形象。",
  },
  {
    title: "注意版本一致性",
    icon: "ri-git-branch-line",
    desc: "不同来源的整理版本在章节划分上可能不同，建议固定使用同一套资源，避免出现情节衔接不上的困惑。",
  },
];

export const faqItems = [
  {
    q: "《漂亮的保姆》的小说和漫画内容一致吗？",
    a: "两者围绕同一作品展开，但由于表现媒介不同，小说侧重文字叙述与心理描写，漫画侧重画面与分镜节奏，在细节取舍上可能存在差异。对照阅读可以互为补充。",
  },
  {
    q: "无删减 TXT 与普通版本有什么区别？",
    a: "无删减版本强调内容的完整与章节的连贯，尽量保留原文的叙述细节。普通版本有时会因排版或整理原因出现段落合并、标点不统一等情况。",
  },
  {
    q: "为什么打开 TXT 会出现乱码？",
    a: "这通常不是文件损坏，而是文本编码与阅读器默认编码不匹配。在阅读器里将编码切换为 UTF-8 或 GBK，一般即可恢复正常显示。",
  },
  {
    q: "手机上阅读方便吗？",
    a: "TXT 格式本身非常适配手机阅读。建议使用支持章节导航与书签的阅读器，并适当放大字号、加大行距，以获得更舒适的阅读体验。",
  },
  {
    q: "应该先读小说还是先看漫画？",
    a: "如果更在意情节细节与人物内心，建议先读小说；如果更喜欢直观的画面呈现，可以先看漫画。也可以先看速览与故事背景后再决定顺序。",
  },
  {
    q: "分章资源与整本合集怎么选？",
    a: "追求一次通读、方便收藏的读者适合整本合集；习惯每天读一点、需要断点续读的读者更适合分章资源，两者内容并不冲突。",
  },
  {
    q: "资源排序和章节编号为什么不同来源不一样？",
    a: "不同整理者采用的章节划分标准可能不同，尤其是长篇幅作品容易出现插章或合并。建议选定一个来源后固定使用，避免混淆。",
  },
  {
    q: "本页会保存我的阅读记录吗？",
    a: "本页只是一个阅读资源信息整理页，不会记录或上传你的阅读行为。你的阅读进度与书签均由你使用的本地阅读器保存。",
  },
];

export const relatedTopics = [
  "都市情感",
  "家庭生活",
  "慢热叙事",
  "日常向",
  "成长线",
  "现实题材",
  "群像刻画",
  "生活流",
  "情感细腻",
  "长文本阅读",
];